import type { Issue } from '../types/issue';

// Created/Resolved werden je nach JIRA-Locale unterschiedlich exportiert.
// Wir suchen alle bekannten Schreibweisen.
export const CREATED_KEYS  = ['Created','created','Date Created','Created Date','Erstellt','Created At'] as const;
export const RESOLVED_KEYS = ['Resolved','resolved','Resolution Date','Resolution date','Date Resolved','Closed Date','Date Closed','Gelöst','Resolved At'] as const;

// JIRA-Monate (Englisch).
const JIRA_MONTH: Record<string, number> = {
  Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
  Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
};

// Parser für die Formate, die uns in der Praxis begegnen:
//   • ISO  "2026-06-19T08:19:42.198Z" oder "2026-06-19"
//   • JIRA "11/Jun/26 9:19 AM"        oder "11/Jun/2026"
//   • Deutsch "19.06.2026"
// Liefert null bei Unparsbar.
export function parseFlexibleDate(s: unknown): Date | null {
  if (s instanceof Date) return isNaN(s.getTime()) ? null : s;
  if (typeof s !== 'string') return null;
  const str = s.trim();
  if (!str) return null;

  // ISO o.ä. — Browser-nativ versuchen
  const iso = new Date(str);
  if (!isNaN(iso.getTime())) return iso;

  // JIRA: "DD/MMM/YY HH:MM" oder "DD/MMM/YYYY"
  let m = str.match(/(\d{1,2})\/(\w{3})\/(\d{2,4})/);
  if (m) {
    const mon = JIRA_MONTH[m[2]];
    if (mon == null) return null;
    const yr = m[3].length === 2 ? 2000 + parseInt(m[3], 10) : parseInt(m[3], 10);
    return new Date(yr, mon, parseInt(m[1], 10));
  }

  // Deutsch: "DD.MM.YYYY"
  m = str.match(/(\d{1,2})\.(\d{1,2})\.(\d{2,4})/);
  if (m) {
    const yr = m[3].length === 2 ? 2000 + parseInt(m[3], 10) : parseInt(m[3], 10);
    return new Date(yr, parseInt(m[2], 10) - 1, parseInt(m[1], 10));
  }
  return null;
}

// Liest das erste verfügbare Datums-Feld aus den möglichen Spalten und
// parst es zu Date. Array-Werte: erstes Element.
export function dateFieldOf(row: Issue, keys: readonly string[]): Date | null {
  for (const k of keys) {
    const raw = (row as Record<string, unknown>)[k];
    if (!raw) continue;
    const v = Array.isArray(raw) ? raw[0] : raw;
    const d = parseFlexibleDate(v);
    if (d) return d;
  }
  return null;
}

export function createdOf(row: Issue):  Date | null { return dateFieldOf(row, CREATED_KEYS); }
export function resolvedOf(row: Issue): Date | null { return dateFieldOf(row, RESOLVED_KEYS); }
